import { useMediaQuery } from '@mui/material';

/**
 * Detecta se o app deve renderizar o shell mobile (MobileLayout) em vez do
 * shell desktop (sidebar + topbar).
 *
 * Critério por viewport (media query), não por user agent: reage a
 * rotação/redimensionamento, não depende de lista de UAs (iPadOS se anuncia
 * como Mac) e permite validar no DevTools do desktop.
 *  - largura <= 767.95px (celular em retrato; abaixo do breakpoint `md`);
 *  - ou celular em paisagem: ponteiro por toque (coarse) com altura <= 500px.
 * Tablets (>= 768px) mantêm o shell existente (drawer off-canvas < 1024px).
 */
export const MOBILE_SHELL_QUERY = '(max-width:767.95px), (pointer: coarse) and (max-height:500px)';

export function useIsMobileShell() {
    // noSsr: lê a media query já no primeiro render (evita piscar o layout desktop).
    return useMediaQuery(MOBILE_SHELL_QUERY, { noSsr: true });
}

export default useIsMobileShell;
